define('cartware_checkout/components/advises/review',[
	"cartware/components/_base",
	"cartware_checkout"
], function(
	Component,
	Checkout
) {
	return Component.create({
		init: function() {
			//var _save = Review.prototype.save;

			function _save() {
				if (checkout.loadWaiting != false) return;

				var params = Form.serialize(payment.form);
				if (this.agreementsForm) {
					params += '&'+Form.serialize(this.agreementsForm);
				}

				checkout.setLoadWaiting('review');

				params.save = true;
				var request = new Ajax.Request(
					this.saveUrl,
					{
						method:'post',
						parameters:params,
						onComplete: this.onComplete,
						onSuccess: this.onSave,
						onFailure: checkout.ajaxFailure.bind(checkout)
					}
				);
			}

			Review.prototype.save = function() {
				var self = this
					, args = arguments;

				if (!shippingMethod.isSaved) {
					var _shippingMethodOnSave = shippingMethod.onSave;
					shippingMethod.onSave = function() {
						_shippingMethodOnSave.apply(this, arguments);

						if (shippingMethod.isSaved) {
							setTimeout(function() {
								// _save.apply(self, args); // Can't use "self" here. For some reason IE keeps an old reference.
								_save.apply(review, args);
								if ("accordion" in window) {
									window.accordion._layout();
								}
							}, 10);
						}

						shippingMethod.onSave = _shippingMethodOnSave;
					};

					shippingMethod.save();
				} else {
					_save.apply(this, arguments);
					if ("accordion" in window) {
						window.accordion._layout();
					}
				}
			}
		}
	});
});
